import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import { HasFileBaseMixin } from "@/bryntum-lib/widget/mixins/HasFileBaseMixin.jsx";
import { DEEP_LINK_URL_KEYS } from "@/other/constants/OtherKeys.jsx";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";

export default class ClientFilesTab extends HasFileBaseMixin(ClientsEditorBase) {
  static get $name() {
    return "ClientFilesTab";
  }

  static get type() {
    return "clientfilestab"
  }

  get recordType() {
    return "clientId"
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientEditorFilesGridState
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.client;
  }

  get storeKey() {
    return STORE_KEYS.clientIntegrationsStore;
  }
}
ClientFilesTab.initClass();
